import BrokerNormsBanner from './BrokerNormsBanner';
import BrokerNormsSection from './BrokerNormsSection';

function BrokerNorms() {
  return (
    <div>
      <BrokerNormsBanner />
      <BrokerNormsSection />
    </div>
  );
}

export default BrokerNorms;